import styled from "@emotion/styled/macro";
import { Button, Typography, tokens } from "@sunrun/experience-ui-components";
import { getEnvironment } from "@sunrun/sales-experience-shared";
import { useAppSelector } from "store";
import { getUserInfo, logoutCognito } from "services/cognitoService";
import { getQueryStringParams } from "utils/queryString";

const CognitoUserLabel = () => {
  const cognitoToken = useAppSelector((state) => state.auth.cognitoToken);
  const host = getQueryStringParams()?.host?.toString() ?? "";
  const inLightmile = host === "LIGHTMILE";

  if (getEnvironment() === "production" || !inLightmile || !cognitoToken) {
    return null;
  }

  const email = getUserInfo(cognitoToken)?.email;
  if (!email) {
    return null;
  }

  return (
    <Container data-testid="cognito-user-label">
      <Typography color={tokens.TINTS_OFF_WHITE_20}>
        Cognito User: {email}
      </Typography>
      <Button
        data-testid="cognito-logout-button"
        onClick={() => {
          logoutCognito();
        }}
        color="tertiary"
        size="xs"
      >
        Logout
      </Button>
    </Container>
  );
};

const Container = styled.span`
  display: inline-flex;
  align-items: center;
  margin-left: 12px;
`;

export { CognitoUserLabel };
